<template>
  <div class="half">
    <div
      style="display: flex; width: 100%;align-items: center;justify-content: center; margin-bottom: 3em;"
    >
      <div style="width: 60%;">
        <ratio-cropper
          :ratio="1"
          :picture-id="p.main_image"
          :lazy="false"
        ></ratio-cropper>
      </div>
    </div>
    <h1>{{ p.code }} - {{ p.name }}</h1>
    <ul>
      <li><strong>Programme :</strong> {{ mapNames(p.programs) }}</li>
      <li>
        <strong>Maîtrise d'Oeuvre :</strong>
        {{ getEntrNamesBySlugMatching("archi", p.interlocuteurs_d).join(", ") }}
      </li>
      <li><strong>Mission :</strong> {{ mapNames(p.missions) }}</li>
      <li><strong>Lieu :</strong> {{ p.address }}, {{ p.city }}</li>
      <li><strong>Budget :</strong> {{ formatNumbers(p.cost) }}€</li>
      <li v-for="s in p.surfaces_d.filter(a => a.content)" :key="s.text">
        <strong>{{ s.text }} :</strong> {{ formatNumbers(s.content) }}m²
      </li>
      <li>
        <strong>Dates :&nbsp;</strong>
          <span v-html="p.dates_d.filter(a => a.content).map(s => `<strong>${s.text}</strong> : ${formatDate(s.content)}`).join(' ')"></span>
      </li>
    </ul>
  </div>
</template>
<script>
import RatioCropper from "../../../components/Layout/ApiPictureCropped";
import {
  mapNames,
  getEntrNamesBySlugMatching,
  formatDate,
  formatNumbers,
} from "../../../util/func";

export default {
  name: "Fichette",
  components: { RatioCropper },
  props: {
    p: {}
  },
  methods: {
    mapNames,
    formatNumbers,
    getEntrNamesBySlugMatching,
    formatDate
  }
};
</script>

<style lang="scss">
  .FichettesA5 {
    h1 {
      text-align: center;
      font-size: 18px;
      margin-bottom: 1em;
    }
    strong {
      color: #31287c!important;
    }
    ul {
      li {

      }
    }
  }
</style>
